module.exports = __webpack_public_path__ + "img/Group2.d4d1e88e.svg";